import { connect } from 'react-redux';
import NYSERDA from './NYSERDA';

import { setNYRebate } from '../../common/nyserda/actions';


import { setNYSERDAIsVisible } from './actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    isVisible: state.nyserdaUI.isVisible,
    nyRebate: state.nyserda.nyRebate,
    setNYRebate,
    setNYSERDAIsVisible,
});

const combinedActions = {
    setNYRebate,
    setNYSERDAIsVisible,
};

export default connect(mapStateToProps, combinedActions)(NYSERDA);



// WEBPACK FOOTER //
// ./src/containers/Inputs/NYSERDA/index.js